"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const layout_1 = require("../layout");
const MISSING_ERROR = "Error was swallowed during propagation.";
exports.withUncaughtErrorBoundary = (componentId) => (WrappedComponent) => { var _a; return _a = class WithPermissionDeniedHandler extends React.Component {
        constructor() {
            super(...arguments);
            this.state = {
                error: undefined
            };
            this.logErrorToCloud = (error, info) => {
                track(`${componentId}: UncaughtError`, { category: "error" });
                // logger.error(`${error} ${info}`);
            };
        }
        componentDidCatch(error, info) {
            this.setState({ error: error || new Error(MISSING_ERROR) });
            this.logErrorToCloud(error, info);
        }
        render() {
            const { error } = this.state;
            if (error) {
                return React.createElement(layout_1.PageLayout, { title: "Something went wrong" });
            }
            else {
                return React.createElement(WrappedComponent, Object.assign({}, this.props));
            }
        }
    },
    _a.displayName = WrappedComponent.name,
    _a; };
